import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchReferralMe,
  isReferralAvailable,
} from '../../store/slices/referralSlice';

// Whether the sidebar shows Refer & Earn, kept in step with the company
// selected in the changer.
//
// layout.js fetches Me once, in getCompanyList, for the company it selects on
// load. The legacy company list changes the selected company in place
// (setGlobalCompany and nothing else), so without this the entry would keep
// answering for the company the user left. A non-admin's selected company
// changing fetches Me again for the new one, through the slice's own
// latest-request guard: the same-company call getCompanyList has already made
// is deduplicated by the thunk's `condition`, so first load stays at one
// fetch, and a late answer for the company left behind is dropped by the
// reducer. The platform admin has no company of their own (and no entry).
const useReferralNav = (isAdmin) => {
  const dispatch = useDispatch();
  const companyId = useSelector((state) => state.companyReducer.selected?.id);
  const available = useSelector((state) =>
    isReferralAvailable(state.referralReducer.data),
  );

  useEffect(() => {
    if (isAdmin || !companyId) return;
    dispatch(fetchReferralMe({ companyId }));
  }, [dispatch, isAdmin, companyId]);

  return available;
};

export default useReferralNav;
